module.exports = __webpack_public_path__ + "static/media/basico.976d9178.jpg";